import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { FormWizard, TabContent } from 'vue-form-wizard';

export default {
  name: 'CaptureLocation',
  components: {
    FormWizard,
    TabContent,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      tabIndex: 0,

      codedUncoded: ['Uncoded', 'Coded'],
      addressTypes: [],

      postalData: {
        addressType: 1,
        careOf: '',
        code: '',
        contact: '',
        flatName: '',
        flatNumber: '',
        houseNumber: '',
        streetName: '',
        area: '',
        township: '',
        town: '',
        buildingName: ''
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$root.$on('capture_location_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.fillLocationData(this.dataObj.item);
      });
    },
    fillLocationData(item) {
      this.addressTypes = item.addressTypes;
      this.postalData.addressType = item.addressType;
      this.postalData.careOf = item.careOf;
      this.postalData.code = item.code;
      this.postalData.contact = item.addressTypes;
      this.postalData.flatName = item.flatName;
      this.postalData.flatNumber = item.flatNumber;
      this.postalData.houseNumber = item.houseNumber;
      this.postalData.streetName = item.streetName;
      this.postalData.area = item.area;
      this.postalData.township = item.township;
      this.postalData.town = item.town;
      this.postalData.buildingName = item.buildingName;
    },
    onComplete: function () {

      this.$root.$emit('scroll_to_end');
      this.$alertMsg(this.$t('activities.CaptureLocationConfirmed'), 2);
    },
    validate1stTab: function () {
      this.tabIndex = 1;

      this.setLocationData();

      return true;
    },
    showInGoogleMap() {
      var address = '';
      if (this.postalData.addressType === 1)
        address = this.postalData.buildingName;
      else if (this.postalData.addressType === 0)
        address = this.postalData.buildingName;

      window.open('http://map.google.com/?oe=utf8&q={0}' + address);
    },
    setLocationData() {

      var location = {
        addressType: this.postalData.addressType,
        careOf: this.postalData.careOf,
        code: this.postalData.code,
        flatName: this.postalData.flatName,
        flatNumber: this.postalData.flatNumber,
        houseNumber: this.postalData.houseNumber,
        streetName: this.postalData.streetName,
        area: this.postalData.area,
        township: this.postalData.township,
        town: this.postalData.town,
        buildingName: this.postalData.buildingName
      }

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(location))
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CaptureLocationDetailsActivity/SetData', parameter)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SetCaptureLocationDataSuccess'), 2);
            loader.hide();
            return true;
          }
          else {
            this.$alertMsg(this.$t('messages.SetCaptureLocationDataFailure'));
            loader.hide();
            return false;
          }
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
          return false;
        });
    },
  },
  
}

